
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-portal/my-positions",
      function () {
        return require("private-next-pages/job-portal/my-positions/index.tsx");
      }
    ]);
  